import React from 'react'

const HeroApplyArrow = props => {
  return (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 64">
      <polygon points="18.23 0 58 32 18.23 64 18.23 50.09 0 50.09 0 13.91 18.23 13.91 18.23 0"/>
    </svg>
  )
}

export default HeroApplyArrow


// WEBPACK FOOTER //
// ./src/assets/icons/hero-apply-arrow.js